import { Component, OnInit, Input } from '@angular/core';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { DatatableConfigurationMapperService } from '../../../analytics-core/services/datatable-configuration.mapper.service';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { R10ConversionsComponent } from '../r10-conversions/r10-conversions.component';

@Component({
	selector: 'app-r2-conversions',
	templateUrl: './r2-conversions.component.html',
	styleUrls: ['./r2-conversions.component.css']
})
export class R2ConversionsComponent extends R10ConversionsComponent implements OnInit {
	@Input() downloadconfig: string;
	@Input() downloadcsvcolumns: any;

	public downloadConfiguration: DownloadConfig;
	public downloadCSVColumns: any;
	public tooltipOptions = {
		arrow: true
	};

	constructor(
		protected analyticsDataModel: AnalyticsDataModel,
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected dataTableService: DatatableConfigurationMapperService
	) {
		super(analyticsDataModel, analyticsService, colorUtilityService, dataTableService);
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.downloadCSVColumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
	}

	processDeviceColor(responseData: any): void {
		const colorArray = [
			this.colorPalette.primaryColor,
			this.colorPalette.secondaryColor,
			this.colorPalette.tertiaryColor,
			this.colorPalette.quinaryColor,
			this.colorPalette.quaternaryColor
		];
		for (let j = 0; j < this.multichartconfigurations.length; ++j) {
			this.multichartconfigurations[j].chartConfig.series[0].colors = colorArray.slice(0, responseData.length);
		}
		this.deviceCount = 'device-' + responseData.length;
	}

	processResponseData(responseData: any): void {
		this.processDeviceColor(responseData);
		for (const metric of this.metricsArray) {
			if (metric) {
				const sum_conversions = responseData.reduce((s, f) => s + Number(f[metric.valueKey]), 0);
				const all_conv_sum = responseData.reduce((s, f) => s + Number(f['all_conversions']), 0);
				this.totalsArray['conversions'] = sum_conversions;
				this.totalsArray['all_conversions'] = all_conv_sum;
				this.totalsArray['conversion_rate'] = ((sum_conversions / parseInt(responseData[0].clicks)) * 100).toFixed(2);
			}
		}

		this.metricObject = [
			{
				name: 'Conversions',
				value: this.totalsArray['conversions'].toLocaleString(),
				tooltip:
					'An action that’s counted when someone interacts with your ad or free product listing, then takes an action you’ve defined as valuable to your business, such as a purchase or a phone call.'
			},
			{
				name: 'Conversion Rate',
				value: this.totalsArray['conversion_rate'] + '%',
				tooltip: 'The average number of conversions per ad interaction, as a percentage.'
			},
			{
				name: 'All Conversions',
				value: this.totalsArray['all_conversions'].toLocaleString(),
				tooltip:
					'A calculation of all the conversions that Google Ads drives for your business, including any actions being excluded from your tracking metrics.'
			}
		];
		responseData = this.conversionsDataProcess(responseData);
		this.multichartconfigurations[0].chartConfig.xAxis[0].labels.formatter =
			this.getXaxisToolTipFormatter(responseData);
		this.devicesChartData = responseData;
		this.deviceLegendData = [];
		for (const responseObj of responseData) {
			let resultObj: object = {};
			this.multidatatableconfigurations.forEach((datatableConfig) => {
				resultObj = {
					...{},
					...resultObj,
					...this.dataTableService.generateDatatableSourceDataFromConfig(responseObj, datatableConfig.columns)
				};
			});
			this.deviceLegendData.push(resultObj);
		}
	}

	getXaxisToolTipFormatter(data): any {
		return function (): string {
			let index = this.axis.categories.indexOf(this.value);
			let text = data[index].tooltip
				? `<div class="sem-tooltip">
        <span>${data[index].tooltip}</span>
        <span class="sem-arrow"></span>
    </div>`
				: '';
			return (
				`<span aria-label="${data[index].tooltip}" class="sem-legend" >
                    <span class="sem-legendname">${this.value}</span>` +
				text +
				`</span>`
			);
		};
	}

	downloadCSV(e: any): void {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey,
			this.downloadConfiguration.fileName,
			this.downloadCSVColumns
		);
	}
}
